"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mountEmptyProject = void 0;
var react_1 = __importDefault(require("react"));
var EmptyProject_1 = require("./EmptyProject");
var CreateBlockButton_1 = require("Project/BlockNew/CreateBlockButton");
var mountEmptyProject = function (mountReactComponent, blockList, dropzonesStore, dragStore, di, usingFeature, blockCreator) {
    var onAddBlock = function (block) {
        blockCreator.createAndInsert(block.blockType, 0, block.preset);
    };
    var renderCreateBlockButton = di.invoke(CreateBlockButton_1.initialiseCreateBlockButtonForEmptyProjectContainer, null, {
        onAddBlock: onAddBlock,
    });
    return mountReactComponent(react_1.default.createElement(EmptyProject_1.EmptyProjectController, { blockList: blockList, dragStore: dragStore, dropzonesStore: dropzonesStore, renderCreateBlockButton: renderCreateBlockButton, usingFeature: usingFeature }));
};
exports.mountEmptyProject = mountEmptyProject;
